<ion-header>
  <ion-toolbar color="primary">
    <ion-title slot="start" color="secondary" class="ion-hide-md-down">
      RAMUS.JE TICHÁ AUKCE
    </ion-title>
    <ion-title slot="start" color="secondary" class="ion-hide-md-up">
      TICHÁ AUKCE
    </ion-title>

    <ion-buttons slot="end">
      <!-- Desktop view -->
      <div class="ion-hide-md-down">
        <ion-button (click)="login()" *ngIf="!isLoggedIn()" >
          <ion-icon slot="start" name="person-circle-outline"></ion-icon>
          <div class="toolbarBtnText ion-text-wrap">Přihlásit /<br>Registrovat</div>
        </ion-button>
        <ion-button [routerLink]="['/profile']" *ngIf="isLoggedIn()">
          <ion-icon slot="start" name="person-outline"></ion-icon>
          <div class="toolbarBtnText">Můj profil</div>
        </ion-button>
        <ion-button (click)="logout()" *ngIf="isLoggedIn()">
          <ion-icon slot="start" name="log-out-outline"></ion-icon>
          <div class="toolbarBtnText">
            Odhlásit
          </div>
        </ion-button>
      </div>

      <!-- Mobile view -->
      <div class="ion-hide-md-up">
        <ion-button (click)="openMobileMenu()">
          <ion-icon slot="icon-only" name="menu"></ion-icon>
        </ion-button>
      </div>
    </ion-buttons>
  </ion-toolbar>

    <ion-toolbar *ngIf="countdownService.isTimeToBeSorry()" color="tertiary">
<!--      <ion-title>-->
        <div class="sorryText">
            Omlouváme se za technické potíže, nyní už můžete vesele přihazovat.
        </div>
<!--      </ion-title>-->

    </ion-toolbar>

  <ion-toolbar *ngIf="countdownService.isAuctionRunning()">
      <ion-title id="countdownText">
        Aukce skončí za {{countdownService.getRemainingDaysToEnd()}}
        <countdown
              (event)="countdownService.handleEvent($event)"
              [config]="countdownToEndConfig"
        ></countdown>.
      </ion-title>
  </ion-toolbar>
    <ion-toolbar *ngIf="countdownService.isAuctionEnded()">
        <ion-title>
            Aukce již skončila.
        </ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>
  <ion-grid id="mainGrid">

    <ion-row>
      <ion-col size-xs="12" size-sm="4">

<!--        <ion-button (click)="addData()"></ion-button>-->

        <p>
          Vítejte na online Tiché aukci umění pro Ramus!
        </p>

        <p>
          Co to je ten Ramus? Jsme spolek, který již patnáct let pořádá akce pro lidi s postižením i bez něj. Nevyužíváme granty ani dotace a opíráme se o individuální a firemní dárce, kteří nás chtějí vědomě podpořit. Koukněte na naše stránky <a href="https://www.ramus.je" target="_blank">www.ramus.je</a> a zjistíte víc.
        </p>

        <p>
          Co to je Tichá aukce umění? Tohle.
        </p>

        <span>
          Jak to bude probíhat?
        </span>
        <read-more class="auctionRules" [maxLength]="0" moreText="To si přečtěte tady v pravidlech" lessText="Schovat" ellipsis="" text="

        <ol>
          <li>
            Aukce začíná v neděli 8.12. v 19:00 a končí ve středu 11.12. v 19:00.
            <p></p>
          </li>
          <li>
            Při registraci uveďte jméno, e-mail a heslo, ověřování není potřeba. Zadejte také přezdívku, která pak bude uvedena u díla, kde budete mít aktuálně nejvyšší příhoz.
            <p></p>
          </li>
          <li>
            Pokud jste se pod tímto e-mailem registrovali v předchozích letech a nepamatujete si heslo, respektive se vám objevuje hláška 'Zadán existující e-mail s chybným heslem,...',  tak si nastavte nové skrze možnost 'Zapomněli jste si heslo?'.
            <p></p>
          </li>
          <li>
            U díla, které jste si vybrali, uveďte cenu, za kterou ho chcete koupit. Musíte však aktuální cenu přehodit alespoň o 50 Kč.
            <p></p>
          </li>
          <li>
            Počet příhozů a vámi dražených děl není omezený, dílo získá člověk s nejvyšší nabídkou na konci aukce.
            <p></p>
          </li>
          <li>
            Vyvolávací cena je uvedena u každého díla, za dar pro Ramus se považuje finální cena snížená o tuto vyvolávací cenu. Potvrzení o daru Vám rádi vystavíme.
            <p></p>
          </li>
          <li>
            Po skončení aukce Vás kontaktujeme a domluvíme se na předání díla, které jste vydražili.
            <p></p>
          </li>
        </ol>"></read-more>

        <p>
          Předem děkujeme a přejeme úspěšný lov umění!
        </p>

      </ion-col>


      <ion-col size-xs="12" size-sm="8">

        <ion-row *ngIf="!this.countdownService.auctionStarted" id="countdown">
            <div>
              Aukce začíná za
            </div>
            <div>
              {{countdownService.getRemainingDaysToStart()}}
              <countdown
                    (event)="countdownChanged($event)"
                    [config]="countdownToStartConfig"
              ></countdown>
            </div>

            <div id="countdownImg">
              <img src="assets/obrazek-aukce.jpg" >
            </div>
        </ion-row>

        <ion-row *ngIf="this.countdownService.auctionStarted || isAdmin()">
          <ion-col id="loading" *ngIf="loading">
<!--            <div>Načítám aukci</div>-->
            <ion-spinner name="dots"></ion-spinner>
          </ion-col>
          <ion-col size-xs="12" size-lg="6" *ngFor="let photo of photos$ | async">
            <ion-card class="image-card">
                <a [href]="photo.url" target="_blank">
                  <img [src]="photo.url">
                </a>
              <ion-card-header>
                <ion-card-title>
                  <ion-row>
                    <ion-col size-xs="12">
                      <div class="photo-title">{{photo.title}}</div>
                      <div class="photo-author">{{photo.author}}</div>
                      <div class="photo-sizeDesc">
                        {{photo.sizeDesc}}
                      </div>
                      <read-more class="photo-desc" [text]="photo.desc" [maxLength]="50">
<!--                        <div class="desc">-->
<!--                          {{photo.desc}}-->
<!--                        </div>-->
                      </read-more>
                    </ion-col>
                  </ion-row>
                </ion-card-title>
              </ion-card-header>
              <ion-card-content class="image-card-content">
                          <div class="image-content-wrapper">
                            <ion-row>
                              <ion-col size-xs="12">
                                <div class="price-title">
                                  Aktuální cena
                                </div>
                                <span class="price-price">{{photo.currentPrice}}</span>
                                <span class="price-unit"> Kč</span>
                                  <span *ngIf="photo.currentPrice !== photo.initialPrice" class="price-topper"> od {{photo.currentTopper?.name}}</span>
                              </ion-col>
                            </ion-row>
                            <!-- <ion-button color="dark" expand="block" size="default">Aukce již skončila. Děkujeme!</ion-button> -->
                            <ion-button color="primary" expand="block" size="default" (click)="showPrihoditOrLogin(photo)" [disabled]="this.countdownService.isAuctionEnded()">Přihodit</ion-button>
                        </div>
              </ion-card-content>
            </ion-card>
          </ion-col>
        </ion-row>
      </ion-col>
    </ion-row>

    <ion-row class="foot">
      <ion-col>
        <div id="furtneco">
          Furt něco a pořád nic.
        </div>
        <div>
          <a href="https://www.ramus.je">
            <img src="assets/logo.png" alt="Ramus.je logo" id="logo">
          </a>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<ion-footer *ngIf="isAdmin()">
  <ion-toolbar>
    <ion-button *ngIf="isAdmin()" (click)="showAdminModal()">Admin</ion-button>
  </ion-toolbar>


<!--  <div>-->
<!--    Furt něco a pořád nic-->
<!--  </div>-->
<!--  <div>-->
<!--    <a href="https://www.ramus.je">-->
<!--      <img src="assets/logo.png" alt="Ramus.je logo" id="logo">-->
<!--    </a>-->
<!--  </div>-->
</ion-footer>
